/* eslint-disable */ // my eslint/prettier config from 'et-webclient' is currently incompatible, need to fix later
import axios from 'axios'
import React, { FC, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import styled from 'styled-components'
import { Button, notification, Typography, Watermark } from 'antd'
import { ShoppingCart } from 'react-feather'
import { FormattedMessage } from 'react-intl'

import { FlexRow } from '../FlexboxReusables/FlexItems'
import {
  CourseAvailableForPurchasePreview,
  CourseCatalogResponse,
  CourseContentPreviewProps,
  CourseDescriptionProps,
  CourseHeaderProps,
  NavigationButtonsProps,
} from './types'
import ExamOverview from './ExamOverview'
import { apiUrl, domain } from '../../globals'
import LoadingSpinner from '../LoadingSpinner'

const defaultCourse: CourseAvailableForPurchasePreview = {
  id: 0,
  name: '',
  description: '',
  pages: [],
  totalPages: 0,
  minPercentageToPass: 0,
  totalPoints: 0,
  questions: [],
  publishedAt: new Date(),
  examDurationInMinutes: 0,
  examValidityMonths: 0,
  purchasePrice: 0,
  maxTries: 0,
}

export const CourseFromCatalog = () => {
  const { courseId } = useParams()

  const [course, setCourse] = useState<CourseAvailableForPurchasePreview>(defaultCourse)
  const [currentPage, setCurrentPage] = useState(0)
  const [showExamOverview, setShowExamOverview] = useState(false)

  useEffect(() => {
    if (courseId) {
      axios
        .get(`${apiUrl}/courses/available-for-purchase?courseId=${courseId}`)
        .then((response) => setCourse(response.data.coursePreviews[0]))
        .catch(() => {
          notification.error({
            message: 'Error',
            description: 'Fehler beim Laden des Kurses',
          })
        })
    }
  }, [courseId])

  const handleNextClick = () => {
    if (currentPage === course.pages.length - 1) {
      setShowExamOverview(true)
    } else {
      setCurrentPage((prev) => prev + 1)
    }
  }

  const handlePrevClick = () => {
    showExamOverview ? setShowExamOverview(false) : setCurrentPage((prev) => prev - 1)
  }

  if (!course.pages.length) {
    return <LoadingSpinner loadingText='Lade Kurs...' />
  }

  return (
    <>
      <CourseHeader title={course.name} />
      <CourseDescription description={course.description} />
      {showExamOverview ? (
        <ExamOverview course={course} />
      ) : (
        <CourseContentPreview course={course} currentPage={currentPage} />
      )}
      <NavigationButtons
        course={course}
        currentPage={currentPage}
        showExamOverview={showExamOverview}
        onNext={handleNextClick}
        onPrev={handlePrevClick}
      />
    </>
  )
}

const CourseHeader: FC<CourseHeaderProps> = ({ title }) => (
  <FlexRow>
    <Typography.Title level={2}>{title}</Typography.Title>
  </FlexRow>
)

const CourseDescription: FC<CourseDescriptionProps> = ({ description }) => (
  <FlexRow margin='0 0 1em 0' padding='0 2em'>
    <DescriptionText>{description}</DescriptionText>
  </FlexRow>
)

const CourseContentPreview: FC<CourseContentPreviewProps> = ({ course, currentPage }) => {
  const page = course.pages[currentPage]
  const previewUrl = `${domain}/images/${course.id}/${page.pageNumber}.jpg`

  return (
    <>
      <FlexRow>
        <Watermark content={'CourseWare'}>
          <PdfPageAsImage
            src={previewUrl}
            onError={(e) => (e.currentTarget.style.display = 'none')}
            alt={`Seite ${page.pageNumber}`}
          />
        </Watermark>
      </FlexRow>
      <FlexRow margin='2em 0'>
        <Typography.Text italic strong>
          <FormattedMessage
            id='courseFromCatalog.previewPagesVsTotalPages'
            values={{ coursePages: course.pages.length, totalPages: course.totalPages }}
          />
        </Typography.Text>
      </FlexRow>
    </>
  )
}

const NavigationButtons: FC<NavigationButtonsProps> = ({ course, currentPage, showExamOverview, onNext, onPrev }) => (
  <FlexRow justifyContent='space-between' margin='2em 0' padding='0 3em'>
    <Button type='primary' onClick={onPrev} disabled={currentPage === 0}>
      <FormattedMessage id='generic.previous' />
    </Button>
    <Button type='primary' onClick={onNext}>
      {showExamOverview ? (
        <Link to={`/buy-course-access/${course.id}`} state={{ course }} style={{ color: 'inherit' }}>
          <FlexRow>
            <ShoppingCart size={18} style={{ marginRight: '1em' }} />
            <FormattedMessage id='generic.buy' />
          </FlexRow>
        </Link>
      ) : (
        <FormattedMessage id='generic.next' />
      )}
    </Button>
  </FlexRow>
)

export default CourseFromCatalog

const PdfPageAsImage = styled.img`
  width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 4px;
  transition: transform 0.3s ease-in-out;
  box-shadow: 2px 2px 4px rgba(234, 225, 225, 0.5);
`

const DescriptionText = styled(Typography.Text)`
  max-width: 80%;
  text-align: left;
`
